import React, { useState } from "react";
import ReactGA from "react-ga4";
import {
  Container,
  PartnerName,
  MenuButtonIcon,
  MenuIcon,
  SideMenu,
  PartnerImg,
  TopHeader,
  Trapezoid,
  SocialContainer,
  WhatsAppIcon,
  PhoneIcon,
  BottomHeader,
} from "./styles";
import { THeaderComponent } from "../../@types/component/THeaderComponent";
import { onlyNumbers, removeDDI } from "../../utils/numberUtils";

export const Header: React.FC<THeaderComponent> = ({
  partnerName,
  logo,
  menuLinks = [],
  socialNetworks,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);

  const OpenMenu = () => {
    setMenuIsOpen(!menuIsOpen);
  };

  const onClickWhatsapp = (whatsappNumber: string) => {
    ReactGA.event({
      category: "Clique Externo",
      action: `Botão Whatsapp`,
      label: `https://web.whatsapp.com/send?phone=${onlyNumbers(
        whatsappNumber
      )}`,
      nonInteraction: true,
    });
    window.open(
      `https://web.whatsapp.com/send?phone=${onlyNumbers(whatsappNumber)}`,
      "_blank"
    );
  };

  const getMenuLinks = () =>
    menuLinks.map((item) => {
      if (item.link === "faq") {
        return {
          name: item.name,
          goToPage: () => {
            setMenuIsOpen(false);
          },
        };
      }
      return {
        name: item.name,
        goToPage: () => {
          setMenuIsOpen(false);
          if (item.target === "_blank") {
            window.open(item.link, item.target);
          } else {
            window.location.href = item.link;
          }
        },
      };
    });

  return (
    <Container>
      {socialNetworks &&
        (socialNetworks.whatsapp ||
          socialNetworks.phone1 ||
          socialNetworks.phone2) && (
          <TopHeader>
            <div />
            <div>
              <Trapezoid />
              {socialNetworks.phone1 && (
                <SocialContainer>
                  <PhoneIcon />
                  <p>Telefone: {removeDDI(socialNetworks.phone1)}</p>
                </SocialContainer>
              )}
              {socialNetworks.phone2 && (
                <SocialContainer>
                  <PhoneIcon />
                  <p>Telefone: {removeDDI(socialNetworks.phone2)}</p>
                </SocialContainer>
              )}
              {socialNetworks.whatsapp && (
                <SocialContainer
                  cursor="pointer"
                  onClick={() =>
                    onClickWhatsapp(socialNetworks.whatsapp as string)
                  }
                >
                  <WhatsAppIcon />
                  <p>Whatsapp: {removeDDI(socialNetworks.whatsapp)}</p>
                </SocialContainer>
              )}
            </div>
          </TopHeader>
        )}
      <BottomHeader>
        {logo ? (
          <PartnerImg img={logo} />
        ) : (
          <PartnerName type="h1">{partnerName}</PartnerName>
        )}

        {/* <MenuButtonIcon
          id="menuButtonIconHeader"
          onClick={OpenMenu}
          icon={<MenuIcon name="menu" id="menuIconHeader" />}
        />

        <SideMenu
          id="sideMenuHeader"
          toggle={OpenMenu}
          open={menuIsOpen}
          items={getMenuLinks()}
        /> */}
      </BottomHeader>
    </Container>
  );
};

export default Header;
